import { useState } from "react";
import { Row, Col, Drawer } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import Container from "../../common/Container";
import {
  HeaderSection,
  LogoContainer,
  Burger,
  NotHidden,
  Menu,
  CustomNavLinkSmallAlt,
  Label,
  Outline,
  Span,
} from "./styles";

const Header = ({ t }: { t: TFunction }) => {
  const [visible, setVisibility] = useState(false);

  const toggleButton = () => {
    setVisibility(!visible);
  };

  const MenuItem = () => {
    return (
      <>
        <CustomNavLinkSmallAlt to="/about">
          <Span>{t("About me")}</Span>
        </CustomNavLinkSmallAlt>
        <CustomNavLinkSmallAlt to="/projects">
          <Span>{t("Projects")}</Span>
        </CustomNavLinkSmallAlt>
        <CustomNavLinkSmallAlt to="/contact">
          <Span>{t("Contact")}</Span>
        </CustomNavLinkSmallAlt>
      </>
    );
  };

  return (
    <HeaderSection>
      <div id="header-div"></div>
      <Container>
        <Row justify="space-between">
          <LogoContainer to="/" aria-label="homepage">
            {/* <SvgIcon src="logo3.png" width="101px" height="64px" /> */}
            <img
              style={{ border: 0, height: 64 }}
              src="/img/icons/logo_small.png"
              alt="ANS"
            />
          </LogoContainer>
          <NotHidden>
            <MenuItem />
          </NotHidden>
          <Burger onClick={toggleButton}>
            <Outline />
          </Burger>
        </Row>
        <Drawer closable={false} open={visible} onClose={toggleButton}>
          <Col style={{ marginBottom: "2.5rem" }}>
            <Label onClick={toggleButton}>
              <Col span={12}>
                <Menu>Menu</Menu>
              </Col>
              <Col span={12}>
                <Outline />
              </Col>
            </Label>
          </Col>
          <MenuItem />
        </Drawer>
      </Container>
    </HeaderSection>
  );
};

export default withTranslation()(Header);
